"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WhenNotNullCondition {
    constructor(expression) {
        this.expression = expression;
    }
    shouldDoValidation(input) {
        try {
            return this.expression(input) != null;
        }
        catch (e) {
            return false;
        }
    }
}
exports.WhenNotNullCondition = WhenNotNullCondition;
//# sourceMappingURL=WhenNotNullCondition.js.map